export default __webpack_public_path__ + "static/media/mage_stars-b-fill.7b13bed5.svg";